"use client";
import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import ErrorFallback from "@/components/common/ErrorFallback";
import { reportClientError, getErrorDedupKey, isErrorAlreadyReported, markErrorAsReported } from "@/lib/errorReporter";
import StackTrace from "stacktrace-js";

export default function GlobalError({ error, reset }) {
  const pathname = usePathname();
  useEffect(() => {
    const href =
      typeof window !== "undefined" ? window.location.href : pathname;
    (async () => {
      let frames = [];
      try {
        if (error) {
          const stackFrames = await StackTrace.fromError(error);
          frames = stackFrames.map((f) => ({
            fileName: f.fileName,
            functionName: f.functionName,
            lineNumber: f.lineNumber,
            columnNumber: f.columnNumber,
          }));
        }
      } catch {}
      const context = {
        subject: "Global App Error",
        layout: "root-boundary",
        route: href,
        resolved_frames: frames,
        error_source: "error.jsx",
      };
      const key = getErrorDedupKey(error, context);
      if (isErrorAlreadyReported(key)) return;
      markErrorAsReported(key);
      reportClientError(error, context);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <ErrorFallback
      title="Oops! Something broke"
      description={error?.message || "An unexpected error occurred."}
      onRetry={() => reset()}
    />
  );
}
